import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withResponsive } from '$util/theme';
import { Card } from '$components/basic/Card';
import { Image } from '$components/basic/Image';
import { StyledCol, Div } from './styled';

const playerCarImage = {
  'Tanguy Ndombele': '/footballers/Tanguy_Ndombele_o4koai.png',
  'Pierre-Emerick Aubameyang': '/footballers/PierreEmerick_Aubameyang_iwklmy.png',
  'Roberto Firmino': '/footballers/Roberto_Firmino_daellk.png',
  'Paul Pogba': '/footballers/Paul_Pogba_pn4lq7.png',
  'David De Gea': '/footballers/David_De_Gea_qzhrlf.png',
  "N'Golo Kante": '/footballers/NGolo_Kante_mfyqua.png',
  'Heung-Min Son': '/footballers/HeungMin_Son_rmwfwk.png',
  'Dele Alli': '/footballers/Dele_Alli_eziphf.png',
  'Angelo Ogbonna': '/footballers/Angelo_Ogbonna_zwnh1f.png',
  'Joao Moutinho': '/footballers/Joao_Moutinho_yfakiw.png',
};

const ResponsiveDiv = withResponsive(Div);

const Player = ({ number, name, minute, value, team, car }) => (
  <StyledCol xs={12} md={2}>
    <Card>
      <ResponsiveDiv displayFrom="md">
        <div className="up">
          <Image provider="cloudinary" src={playerCarImage[name]} layout="fill" objectFit="cover" />
        </div>
        <div className={classNames('down', { 'down-minute': minute })}>
          <div className="name-div">
            <span>{number}</span>
            <div>
              <p className="name">{name}</p>

              {minute ? <p className="minute">{minute}</p> : <p className="value">£{value}</p>}
            </div>
          </div>
          <div className="lower-div">
            <div className="team">
              <p>Team</p>
              <p>{team}</p>
            </div>
            <div className={classNames('car', { 'car-minute': minute })}>
              <p>Car</p>
              <p>{car}</p>
            </div>

            {minute && (
              <div className="value-minute">
                <p>Value</p>
                <p>£{value}</p>
              </div>
            )}
          </div>
        </div>
      </ResponsiveDiv>

      <ResponsiveDiv displayTo="md">
        <div className="up">
          <div className="img-div">
            <Image provider="cloudinary" src={playerCarImage[name]} layout="fixed" width="88" height="88" />
          </div>
          <div className="name-div">
            <span>{number}</span>
            <div>
              <p className="name">{name}</p>

              {minute ? <p className="minute">{minute}</p> : <p className="value">£{value}</p>}
            </div>
          </div>
        </div>
        <div className={classNames('down', { 'down-minute': minute })}>
          <div className="team">
            <p>Team</p>
            <p>{team}</p>
          </div>
          <div className={classNames('car', { 'car-minute': minute })}>
            <p>Car</p>
            <p>{car}</p>
          </div>

          {minute && (
            <div className="value-minute">
              <p>Value</p>
              <p>£{value}</p>
            </div>
          )}
        </div>
      </ResponsiveDiv>
    </Card>
  </StyledCol>
);

Player.propTypes = {
  number: PropTypes.number,
  name: PropTypes.string,
  minute: PropTypes.string,
  value: PropTypes.string,
  team: PropTypes.string,
  car: PropTypes.string,
};

Player.defaultProps = {
  number: null,
  name: '',
  minute: '',
  value: '',
  team: '',
  car: '',
};

export default Player;
